import { globalWindow } from '../global-window';
import { Breakpoints } from './breakpoints';

export type ActiveBreakpoints = {
    medium: boolean
    large: boolean
    xLarge: boolean
};

export const queryMedium = `screen and (min-width: ${Breakpoints.MEDIUM}px)`;
export const queryLarge = `screen and (min-width: ${Breakpoints.LARGE}px)`;
export const queryMLarge = `screen and (min-width: ${Breakpoints.M_Large}px)`;
export const queryXLarge = `screen and (min-width: ${Breakpoints.X_LARGE}px)`;

export const getActiveBreakpoints = () => ({
  medium: globalWindow.matchMedia(queryMedium).matches,
  large: globalWindow.matchMedia(queryLarge).matches,
  mLarge: globalWindow.matchMedia(queryMLarge).matches,
  xLarge: globalWindow.matchMedia(queryXLarge).matches,
});

export const isMobile = () => {
    const { medium, large, xLarge } = getActiveBreakpoints();
    return !(medium || large || xLarge);
};

export const isLargeDesktop = () => {
    const { mLarge, xLarge } = getActiveBreakpoints();
    return (mLarge || xLarge);
};
